import React from "react";
import {ContentKey, FunnelKey, RoleKey} from "../models/Keys";

type AnyKey = FunnelKey | RoleKey | ContentKey;

class SetStyleRegistry {
    private registry: Map<AnyKey, React.RefObject<HTMLElement>[]> = new Map();
    private is_dispachable: boolean = false;

    add(key: AnyKey, ref: React.RefObject<HTMLElement>) {
        const refs = this.registry.get(key);
        if (refs === undefined) {
            this.registry.set(key, [ref]);
        } else {
            refs.push(ref);
        }
    }

    remove(key: AnyKey, ref: React.RefObject<HTMLElement>) {
        const refs = this.registry.get(key);
        if (refs) {
            this.registry.set(key, refs.filter(r => r !== ref))
        }
    }

    dispatch(key: AnyKey, style: React.CSSProperties) {
        if (this.is_dispachable) {
            this.registry.get(key)?.forEach(ref => {
                if (ref.current) {
                    ref.current.style.transform = style.transform ?? '';
                }
            });
        }
    }

    start() {
        this.is_dispachable = true;
    }

    stop() {
        this.is_dispachable = false;
    }

}

const setStyleRegistry = new SetStyleRegistry();

export function useSetStyleRegistory() {
    return setStyleRegistry;
}
